<template>
  <button class="btn-float top right"
          :class="{'comment-mode': commentMode, 'countdown': countdown}"
          :style="style"
          @click="click">
    <span class="counter"
          id="counter"></span>
    <i class="mdi mdi-close"></i>

  </button>
</template>

<script>
export default {
  data() {
    return {
      countdownInterval: null,
      secondsCount: undefined,
    };
  },

  props: {
    commentMode: {
      type: Boolean,
      required: true,
    },
    countdown: {
      type: Boolean,
      default: false,
    },
    countdownEnded: {
      type: Boolean,
    },
    seconds: {
      type: Number,
    },
    videoMinimumTime: {
      type: Number,
      required: false,
    },
    positioning: {
      type: Number,
      required: false,
    },
  },

  watch: {
    countdown(val) {
      if(this.countdownEnded) return

      const isCounting = this.countdownInterval;

      if (val) {
        if (!isCounting) {
          this.startCloseCountdown();
        } else {
          this.showCountdownNumber();
        }
      }

      if (!val) {
        this.hideCountdownNumber();
      }
    },
  },

  computed: {
    isValidPositioning() {
      return this.positioning > 0;
    },
    style() {
      return {
        right: this.isValidPositioning ? `${this.positioning}px` : "",
      };
    },
  },

  methods: {
    showCountdownNumber() {
      document.querySelector(".mdi-close").style.display = "none";
      document.querySelector("#counter").style.display = "block";
      document.querySelector("#counter").innerText = this.secondsCount;
    },
    hideCountdownNumber() {
      document.querySelector(".mdi-close").style.display = "block";
      document.querySelector("#counter").style.display = "none";
    },
    stopCountdown() {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;

      this.hideCountdownNumber();

      this.$emit("count-over");
    },
    click(evt) {      
      if (this.countdown && !this.countdownEnded) return

      if (!this.commentMode) return this.$emit("next", evt);
     
      this.$emit("close-comment", false);
    },

    startCloseCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }

      this.secondsCount = this.videoMinimumTime;

      this.showCountdownNumber();

      this.countdownInterval = setInterval(() => {
        this.secondsCount--;

        if (this.countdown) {
          document.querySelector("#counter").innerText = this.secondsCount;
        }

        if (this.secondsCount <= 0) {
          this.stopCountdown();
        }
      }, 1000);
    },
  },

  mounted() {
    if (this.countdown) this.startCloseCountdown();
  },

  beforeDestroy() {
    clearInterval(this.countdownInterval);
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.btn-float {
  transition: all 0.3s;
}

.comment-mode {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  top: 0 !important;
  right: 0 !important;
}

.countdown {
  display: flex;
  justify-content: center;
  align-items: center;
}
.counter {
  display: none;
}
</style>
